/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/jsx-no-comment-textnodes */
import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";

export const config = {
  endpoint: `https://qkart-frontend-m94o.onrender.com/api/v1`,
};

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/register">
          <Register/>
        </Route>
        <Route path="/login">
          <Login/>
        </Route>
        <Route exact path="/">
          <Products/>
        </Route>
        <Route exact path="/checkout">
          <Checkout/>
          </Route>
          <Route exact path="/thanks">
          
          <Thanks/>
          </Route>

        </Switch>


      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
      
      
    </div>
  );
}

export default App;
